import { Component } from "@angular/core";
import { Router } from "@angular/router";
import {
  RequestInBatchService,
  UpdateInBatchEnum,
} from "../shared/services/request-in-batch.service";

@Component({
  selector: "app-edit-request-in-batch",
  templateUrl: "./edit-request-in-batch.component.html",
  styleUrls: ["./edit-request-in-batch.component.scss"],
})
export class EditRequestInBatchComponent {
  public updateInBatchEnum = UpdateInBatchEnum;

  constructor(
    private requestInBatchService: RequestInBatchService,
    public router: Router,
  ) {}

  public updateInBatch(batchEnum: UpdateInBatchEnum) {
    this.requestInBatchService.activateBatchMode(batchEnum);
    void this.router.navigate(["list"]);
  }
}
